import { TypedAction } from '@ngrx/store/src/models';
import { Validator } from '@symphony-solo/shared/error-handling/src';

export class SyncDataValidator {
  private validators: Validator<any>[] = [];

  public addValidator(validator: Validator<any>): SyncDataValidator {
    this.validators.push(validator);
    return this;
  }

  public validate(): TypedAction<any>[] {
    const actions = new Array<TypedAction<any>>();
    this.validators.forEach((validator) => {
      actions.push(validator.validate());
    });
    return actions;
  }
}
